import React, { useState, useEffect } from 'react';
import { getProductos, eliminarProducto } from '../api';
import ModalProducto from './ModalProducto';
import { formatPrecio } from '../utils';
import ModalEditarProducto from './ModalEditarProducto';

function Catalogo() {
  const [productos, setProductos] = useState([]);
  const [cargando, setCargando]   = useState(true);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [productoEditar, setProductoEditar] = useState(null);

  useEffect(() => {
    cargarProductos();
  }, []);

  async function cargarProductos() {
    setCargando(true);
    const data = await getProductos();
    setProductos(data);
    setCargando(false);
  }

  async function handleEliminar(id) {
    await eliminarProducto(id);
    cargarProductos();
  }

  function toggleActivo(id) {
    setProductos(productos.map(p =>
      p.id === id ? { ...p, activo: !p.activo } : p
    ));
  }

  if (cargando) {
    return (
      <div style={styles.loading}>
        <div style={styles.loadingText}>Cargando productos...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>

      <button style={styles.addBtn} onClick={() => setModalAbierto(true)}>
       ＋ Agregar producto
      </button>

      <div style={styles.secHdr}>
        <span style={styles.secTitle}>Mis productos ({productos.length})</span>
      </div>

      {productos.length === 0 && (
        <div style={styles.empty}>
          <div style={styles.emptyIcon}>🛍️</div>
          <div style={styles.emptyTitle}>Sin productos aún</div>
          <div style={styles.emptySub}>Agrega tu primer producto para empezar</div>
        </div>
      )}

      {productos.map(p => (
        <div key={p.id} style={styles.card}>
          <div style={styles.cardInner}>
            <div style={styles.thumb}>
              <div style={{ ...styles.dot, background: p.activo ? '#25D366' : '#7A8F89' }} />
              {p.emoji || '📦'}
            </div>
            <div style={styles.body}>
              <div style={styles.nombre}>{p.nombre}</div>
              <div style={styles.meta}>
                <span style={styles.precio}>{formatPrecio(p.precio)}</span>
                <span style={{
                  ...styles.stockBadge,
                  background: '#F0F4F0',
                  color: '#7A8F89',
                }}>
                  {p.variantes && p.variantes[0]
                    ? `${p.variantes.reduce((a, v) => a + (v?.stock || 0), 0)} piezas`
                    : 'Sin variantes'}
                </span>
              </div>
              <div style={styles.stats}>
                <span style={styles.stat}>
                  {p.variantes ? `${p.variantes.length} variantes` : '0 variantes'}
                </span>
              </div>
            </div>
          </div>

          <div style={styles.actions}>
            <button style={styles.actBtn} onClick={() => setProductoEditar(p)}>
              ✏️ Editar
            </button>
            <button style={styles.actBtn} onClick={() => toggleActivo(p.id)}>
              {p.activo ? '⏸ Pausar' : '▶ Activar'}
            </button>
            <button
              style={{ ...styles.actBtn, color: '#FF4757' }}
              onClick={() => handleEliminar(p.id)}
            >
              🗑
            </button>
          </div>
        </div>
      ))}
    {modalAbierto && (
     <ModalProducto
      onCerrar={() => setModalAbierto(false)}
      onGuardado={() => { setModalAbierto(false); cargarProductos(); }}
    />
    )}
      {productoEditar && (
        <ModalEditarProducto
          producto={productoEditar}
          onCerrar={() => setProductoEditar(null)}
          onGuardado={() => { setProductoEditar(null); cargarProductos(); }}
        />
      )}
    </div>
  );
}

const styles = {
  container:  { padding: 16, paddingBottom: 90 },
  loading:    { display: 'flex', justifyContent: 'center', padding: 40 },
  loadingText:{ color: '#7A8F89', fontSize: 14 },
  addBtn: {
    width: '100%',
    background: 'linear-gradient(135deg, #25D366, #128C7E)',
    color: 'white',
    border: 'none',
    borderRadius: 16,
    padding: 16,
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
    marginBottom: 20,
    boxShadow: '0 4px 16px rgba(37,211,102,0.35)',
  },
  secHdr:     { marginBottom: 14 },
  secTitle:   { fontSize: 16, fontWeight: 800, color: '#0D1F1A' },
  empty:      { textAlign: 'center', padding: '40px 20px' },
  emptyIcon:  { fontSize: 48, marginBottom: 12 },
  emptyTitle: { fontSize: 16, fontWeight: 700, color: '#0D1F1A', marginBottom: 6 },
  emptySub:   { fontSize: 13, color: '#7A8F89' },
  card: {
    background: 'white',
    borderRadius: 16,
    overflow: 'hidden',
    marginBottom: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    border: '1px solid #E4EDE8',
  },
  cardInner:  { display: 'flex', alignItems: 'stretch' },
  thumb: {
    width: 88,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 40,
    position: 'relative',
    background: '#f9f9f9',
  },
  dot: {
    position: 'absolute',
    top: 8, left: 8,
    width: 8, height: 8,
    borderRadius: '50%',
  },
  body:       { flex: 1, padding: '12px 12px 10px 8px' },
  nombre:     { fontSize: 14, fontWeight: 700, color: '#0D1F1A', marginBottom: 4 },
  meta:       { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 },
  precio:     { fontSize: 16, fontWeight: 800, color: '#128C7E' },
  stockBadge: { fontSize: 11, padding: '2px 8px', borderRadius: 20 },
  stats:      { display: 'flex', gap: 12 },
  stat:       { fontSize: 11, color: '#7A8F89' },
  actions:    { display: 'flex', borderTop: '1px solid #E4EDE8' },
  actBtn: {
    flex: 1,
    padding: 10,
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    color: '#128C7E',
    borderRight: '1px solid #E4EDE8',
  },
};

export default Catalogo;